<div class="textarea-wrapper">
  <div class="textarea-container" [ngClass]="{ 'error-state': !getControl().untouched && getControl().invalid }">
    <textarea
      [id]="'textarea-' + getUniqueId()"
      class="textarea-input"
      [placeholder]="label() || ' '"
      [formControl]="getControl()"
      [rows]="rows()"
      [attr.aria-invalid]="!getControl().valid && getControl().touched">
    </textarea>
    @if (label()) {
      <label class="textarea-label" [for]="'textarea-' + getUniqueId()">
        {{ label() }}@if (required()) { <span class="required">*</span> }
      </label>
    }
  </div>
</div>
